var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43538 8.355L1.83838 4.2435C1.41388 3.75975 1.75888 3 2.40313 3H9.59713C9.74131 2.99988 9.88248 3.04132 10.0037 3.11936C10.125 3.1974 10.2211 3.30873 10.2807 3.44002C10.3403 3.57131 10.3608 3.717 10.3397 3.85963C10.3186 4.00227 10.2569 4.1358 10.1619 4.24425L6.56488 8.35425C6.49448 8.43481 6.40767 8.49937 6.31026 8.54361C6.21286 8.58785 6.10711 8.61073 6.00013 8.61073C5.89315 8.61073 5.78741 8.58785 5.69 8.54361C5.59259 8.49937 5.50578 8.43481 5.43538 8.35425V8.355Z",
    fill: "#5AB6DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarArrow);
export default __webpack_public_path__ + "static/media/navbarArrow.fccf5602.svg";
export { ForwardRef as ReactComponent };